import { render, staticRenderFns } from "./taoBao.vue?vue&type=template&id=74cf9dd4&scoped=true&"
import script from "./taoBao.vue?vue&type=script&lang=js&"
export * from "./taoBao.vue?vue&type=script&lang=js&"
import style0 from "./taoBao.vue?vue&type=style&index=0&id=74cf9dd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cf9dd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\项目管理\\旧换新\\源码\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74cf9dd4')) {
      api.createRecord('74cf9dd4', component.options)
    } else {
      api.reload('74cf9dd4', component.options)
    }
    module.hot.accept("./taoBao.vue?vue&type=template&id=74cf9dd4&scoped=true&", function () {
      api.rerender('74cf9dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/taoBao.vue"
export default component.exports